/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    LINK: 'link',
    FILE: 'file',
    TEXT: 'text',
    DEFAULT: 'default',
};
